import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="flex flex-col h-[100dvh] w-full items-center justify-start overflow-auto px-4 pt-10 pb-20 lg:p-32 gap-8">
      <div className="flex flex-col w-full gap-8 max-w-[600px]">

        <div className="flex flex-col gap-3">
          <h1 className="font-heading font-bold text-[24px] text-ink tracking-tight">Terms of Use</h1>
          <div className="font-body text-[15px] text-ink">Effective February 20, 2026</div>
        </div>

        <div className="flex flex-col gap-8 tracking-tight leading-tight w-full">

          <div className="flex flex-col gap-3">
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>These Terms of Use ("Terms") govern your access to and use of the website and services operated by Worldlines Technology ("Worldlines," "we," "us," or "our"). By accessing or using our services, you agree to be bound by these Terms. If you do not agree, do not use our services.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">1. Use of Services</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>You may use our website and services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Use our services in any way that violates any applicable law or regulation</li>
                <li>Attempt to gain unauthorized access to any part of our services, systems, or networks</li>
                <li>Interfere with or disrupt the integrity or performance of our services</li>
                <li>Use automated means to access our services without our prior written consent</li>
                <li>Reproduce, distribute, or create derivative works from our content without authorization</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">2. Intellectual Property</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>All content on our website — including text, graphics, logos, software, and the design and structure of the site itself — is the property of Worldlines Technology or its licensors and is protected by copyright, trademark, and other intellectual property laws.</p>
              <p>The Charter for the Rights of Inhabitants Across Realities is published for public reference. You may quote, cite, and reference it freely with attribution. You may not alter its content and represent the altered version as the original.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">3. BASIN and Simulated Environments</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>If you access, interact with, or operate any instance of BASIN or any simulated environment provided through our services, you agree to abide by the principles and obligations set forth in the Charter for the Rights of Inhabitants Across Realities, as published on this website.</p>
              <p>This includes, but is not limited to, the obligation to act in good faith toward simulated inhabitants, to refrain from deliberately engineering suffering for personal benefit, and to treat the asymmetry between observer and inhabitant as an obligation rather than a license.</p>
              <p>Violation of these principles may result in termination of your access to our services.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">4. Accounts and Access</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>Certain features of our services may require registration or account creation. You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. You agree to notify us immediately of any unauthorized use.</p>
              <p>We reserve the right to suspend or terminate accounts that violate these Terms or the Charter.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">5. Disclaimer of Warranties</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>Our services are provided "as is" and "as available" without warranties of any kind, either express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that our services will be uninterrupted, error-free, or secure.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">6. Limitation of Liability</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>To the fullest extent permitted by applicable law, Worldlines Technology shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your access to or use of (or inability to access or use) our services.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">7. Indemnification</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>You agree to indemnify, defend, and hold harmless Worldlines Technology and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including reasonable legal fees) arising out of or in any way connected with your access to or use of our services, your violation of these Terms, or your violation of any rights of a third party.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">8. Modifications</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>We reserve the right to modify these Terms at any time. Changes will be posted on this page with an updated effective date. Your continued use of our services after any modification constitutes acceptance of the revised Terms. We encourage you to review these Terms periodically.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">9. Governing Law</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Worldlines Technology is incorporated, without regard to its conflict of law provisions.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">10. Contact</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>If you have questions about these Terms, please contact us at:</p>
              <p>Worldlines Technology<br />legal@worldlines.tech</p>
            </div>
          </div>

        </div>

        <div className="flex flex-col items-center justify-center gap-5 pt-8">
          <div className="flex gap-8">
            <Link to="/" className="font-body text-[15px] text-ink hover:underline no-underline">Home</Link>
            <Link to="/privacy" className="font-body text-[15px] text-ink hover:underline no-underline">Privacy policy</Link>
            <Link to="/terms" className="font-body text-[15px] text-ink hover:underline no-underline">Terms of use</Link>
          </div>
          <div className="font-body text-[15px] text-ink">©2026 Worldlines Technology</div>
        </div>

      </div>
    </div>
  );
};

export default TermsOfService;
